var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyVisualWrapper",class:_vm.addClass,style:(_vm.styles)},[_c('div',{class:{ container: !_vm.noContainer }},[_c('div',{staticClass:"visual-container",class:_vm.containerClass},[_c('img',{staticClass:"visual-image",style:(_vm.imageStyles),attrs:{"src":_vm.desktopImageUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }